import React, { useContext, useState } from 'react';
import {
  arrayOf, bool, number, shape, string, object
} from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Drawer, DrawerItem } from '@thd-olt-component-react/drawer';
import { TileHead } from '../../TileHead';
import { StoreOnlyInfoToolTip } from './StoreOnlyInfoToolTip';
import { StoreOnlyInfoMobileDrawer } from './StoreOnlyInfoMobileDrawer';
import { showBopisDate } from '../../../../helper/utils';

const BopisNotFulfillableOOS = ({
  bopisFulfillment, itemId, isShipToHomeEligible, isAppliance, isCartTiles, location
}) => {
  const { channel } = useContext(ExperienceContext);
  let { storeHours } = useStore();
  storeHours = isCartTiles ? bopisFulfillment?.storeHours : storeHours;
  const [tooltipInstance, setInstance] = useState(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);

  const openDrawer = (event) => {
    event.preventDefault();
    setIsQuickViewOpen(true);
  };

  const onAtYourStoreClicked = (event) => {
    if (channel === 'mobile') {
      openDrawer(event);
    } else if (channel === 'desktop') {
      if (tooltipInstance?.hide) {
        tooltipInstance.hide();
      }
    }
  };

  const renderCardDetails = () => {
    return (
      <div role="button" tabIndex={0} className="fulfillment-tile" onClick={onAtYourStoreClicked}>
        <TileHead title="At Your Store" icon="mw-icon-info" />
        <div className="fulfillment__sub-title fulfillment__primary_color">
          <div className="u__bold">{showBopisDate(storeHours)}</div>
          <div>
            <span>{`Visit ${location?.storeName} for availability`}</span>
          </div>
        </div>
      </div>
    );
  };

  return channel === 'desktop' ? (
    <Tooltip
      channel={channel}
      closeButton
      placement="bottom"
      distance={-60}
      onShow={(instance) => {
        setInstance(instance);
      }}
      content={<StoreOnlyInfoToolTip />}
      interactive
    >
      <div>{renderCardDetails()}</div>
    </Tooltip>
  ) : (
    <>
      <div>{renderCardDetails()}</div>
      <Drawer
        open={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
        initialItem="mobile-quick-view"
        position="bottom"
        maxSize={25}
        isMobile
      >
        <DrawerItem name="mobile-quick-view">
          <StoreOnlyInfoMobileDrawer />
        </DrawerItem>
      </Drawer>
    </>
  );
};
BopisNotFulfillableOOS.propTypes = {
  itemId: string.isRequired,
  isShipToHomeEligible: bool,
  isAppliance: bool,
  bopisFulfillment: shape({
    type: string,
    locations: arrayOf(shape({
      isAnchor: bool,
      inventory: shape({
        quantity: number,
        isInStock: bool,
        isLimitedQuantity: bool,
        isBackordered: bool
      })
    }))
  }),
  isCartTiles: bool,
  location: shape({
    storeName: string,
    distance: number
  }).isRequired,
};
BopisNotFulfillableOOS.defaultProps = {
  isShipToHomeEligible: false,
  isAppliance: false,
  bopisFulfillment: null,
  isCartTiles: false
};

export { BopisNotFulfillableOOS };
